import { render } from "./App.vue?vue&type=template&id=7a86c3a3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7a86c3a3&lang=css"
script.render = render

export default script